// First "letter" of a name, for text/initial avatars.
//
// PROJECT RULE: every text/initial avatar in the app must use this — never
// `name[0]` / `charAt(0)`. Thai pre-posed vowels (เ แ โ ใ ไ) and tone marks are
// written BEFORE the base consonant, so a naive first character is wrong; this
// skips them so the base consonant shows:
//   "เอก" → "อ"   "แอร์" → "อ"   "โส่ย" → "ส"   "ไม" → "ม"
// Latin names use the first Latin letter, uppercased ("Dr. Smith" → "D").
export function nameInitial(name) {
  const s = (name || '').trim()
  if (!s) return '?'
  const latin = s.match(/[A-Za-z]/)
  if (latin) return latin[0].toUpperCase()
  const SKIP = /[เ-ไ็-๎\s]/ // pre-posed vowels U+0E40–0E44, tone marks U+0E47–0E4E, spaces
  for (const ch of s) { if (!SKIP.test(ch)) return ch }
  return s[0]
}
